import * as filter from "./filter.ts";

const importFilter = Vue => {
  Vue.filter('toChies', filter.toChies)
}
export default importFilter
